<div class="wrapper">
  <div *ngFor="let obj of displayData" class="individual-wrapper">
    <div class="key">{{ obj.key }}:</div>
    <div class="value" style="font-weight: 500">
      {{ obj.value }}
    </div>
  </div>
</div>
